import React from 'react';
import { Flex, useIsMobile } from '@amzn/storm-ui';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { StyledLink } from 'src/commons/components/StyledLink';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';

export const IA2AccountDropdownFooterLinks: React.VFC = () => {
  const isMobile = useIsMobile();
  const { currentEntityId } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();
  const chromeConfig = useChromeConfigContext();

  // These links are entity-scoped destinations ("manage this entity's accounts").
  // In ALL_ACCOUNTS scope there is no active entity, so hiding them is correct
  // independent of the server-side change that will null currentEntityId —
  // rendering entityId=undefined would be semantically wrong regardless.
  const isCurrentScopeAllAccounts =
    chromeConfig.pageHeader?.pageScope === 'ALL_ACCOUNTS';

  if (isCurrentScopeAllAccounts) {
    return null;
  }

  const managerAccountDiscoveryLink = `/am/managerAccounts/list?entityId=${currentEntityId}&ref_=AAC_unav_discovery_account_dropdown`;

  return (
    <Flex
      data-ccx-e2e-id="account-dropdown-footer-links"
      direction="column"
      rowGap="xxsmall"
      padding={isMobile ? 'xsmall' : 'small base'}
    >
      <StyledLink
        href={`/accounts?entityId=${currentEntityId}&ref_=AAC_unav_manageaccounts`}
        data-ccx-e2e-id="aac-account-management"
        {...getTaktAttributes('manager-account-link', chromeComponents.HEADER)}
      >
        {bundle.getMessage('account-dropdown-manage-accounts-link-label')}
      </StyledLink>
      <StyledLink
        href={managerAccountDiscoveryLink}
        data-ccx-e2e-id="aac-master-account-discovery-link"
        {...getTaktAttributes(
          'ccx-master-account-discovery-link',
          chromeComponents.HEADER,
        )}
      >
        {bundle.getMessage('account-dropdown-create-manager-account-label')}
      </StyledLink>
    </Flex>
  );
};
